import React, { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import Toast, { ToastTitle, ToastDescription } from 'components/Toast/Toast';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { resetToast } from 'modules/app/toasterSlice';

const Toaster: FC = () => {
  const { variant, titlei18nKey, descriptioni18nKey } = useSelector((state: RootState) => state.toaster);
  const toast = useToast();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (variant && titlei18nKey) {
      toast({
        position: 'top-right',
        isClosable: true,
        onCloseComplete: () => dispatch(resetToast()),
        // eslint-disable-next-line react/display-name
        render: props => {
          return (
            <Toast {...props} variant={variant}>
              <ToastTitle>{t(titlei18nKey)}</ToastTitle>
              {descriptioni18nKey && <ToastDescription>{t(descriptioni18nKey)}</ToastDescription>}
            </Toast>
          );
        },
      });
    }
  }, [variant, titlei18nKey, descriptioni18nKey]);
  return null;
};

export default Toaster;
